import React from "react";           // ← يجب أن يكون موجود
import { formatNumber } from "./utils/numberFormat";

export default function TabStock({
  viewMode,
  loading,
  stockItems,
  stockSummary,
  stockMoves,
  stockByService,
  inMoves,
  outMoves,
  setMsg,
}) {
  return (
    <div className="card">
      <h3>Warehouse Inventory (Export Ground Stock)</h3>

      {/* ===== Section 1: Current Stock ===== */}
      
      {/* ===== Section 1: Inventory Status (stock_inventory) ===== */}
      {viewMode === 'stock_inventory' && (
        <div className="card" style={{ marginTop: 12 }}>
          <h4 style={{ margin: 0 }}>Items in Warehouse</h4>
          {Array.isArray(stockItems) && stockItems.length > 0 ? (
            <div className="table-wrap" style={{ marginTop: 12 }}>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>AWB</th>
                    <th>Current</th>
                    <th>Added</th>
                    <th>Withdrawn</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  {stockItems.map((r) => (
                    <tr key={r.bol_reference}>
                      <td>{r.bol_reference}</td>
                      <td>{formatNumber(r.current_qty, 0)}</td>
                      <td>{formatNumber(r.total_in, 0)}</td>
                      <td>{formatNumber(r.total_out, 0)}</td>
                      <td>{r.updated_at ? String(r.updated_at).slice(0, 19).replace("T", " ") : ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="hint-text" style={{ marginTop: 12 }}>No inventory data available. Click "Load Inventory" to fetch data.</p>
          )}
        </div>
      )}

      {/* ===== Section 2: Stock Movements (stock_moves) ===== */}
      {viewMode === 'stock_moves' && (
        <div className="card" style={{ marginTop: 12 }}>
          <h4 style={{ margin: "0 0 12px 0" }}>Stock Movements</h4>
          {stockMoves.length > 0 ? (
            <>
              <div style={{ marginTop: "20px" }}>
                <h4>Stock In (Additions)</h4>
                {inMoves.length > 0 ? (
                  <div className="table-wrap">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>AWB</th>
                          <th>Qty</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inMoves.map((m) => (
                          <tr key={m.id}>
                            <td>{m.created_at ? String(m.created_at).slice(0, 19).replace("T", " ") : ""}</td>
                            <td>{m.bol_reference}</td>
                            <td>{formatNumber(m.qty, 0)}</td>
                            <td>{m.note || ""}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="hint-text">No IN movements found for the selected filters.</p>
                )}
              </div>

              <div style={{ marginTop: "20px" }}>
                <h4>Stock Out (Withdrawals)</h4>
                {outMoves.length > 0 ? (
                  <div className="table-wrap">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>AWB</th>
                          <th>Qty</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        {outMoves.map((m) => (
                          <tr key={m.id}>
                            <td>{m.created_at ? String(m.created_at).slice(0, 19).replace("T", " ") : ""}</td>
                            <td>{m.bol_reference}</td>
                            <td>{formatNumber(m.qty, 0)}</td>
                            <td>{formatNumber(m.note, 0)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="hint-text">No OUT movements found for the selected filters.</p>
                )}
              </div>
            </>
          ) : (
            <p className="hint-text" style={{ marginTop: 12 }}>No stock movements loaded. Click "Load Movements" to fetch data.</p>
          )}
        </div>
      )}

{/* ===== Section 3: Stock by Service - Hierarchical (Master + House) ===== */}
{viewMode === 'stock_service' && (
  <div className="card" style={{ marginTop: 12 }}>
    <h4>Stock By BOL (Master + House)</h4>

    {stockByService?.items && Array.isArray(stockByService.items) && stockByService.items.length > 0 ? (
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>AWB</th>
              <th>Services (Service + Packing + Build Up)</th>
              <th>Qty</th>
              <th>Pieces</th>
              <th>Weight</th>
              <th>Days (Max)</th>
              <th>Status</th>
              <th>Service Cost</th>
              <th>Packing Cost</th>
              <th>Build Up Cost</th>
              <th>Storage Cost</th>
              <th>Total Value (USD)</th>
            </tr>
          </thead>
          <tbody>
            {stockByService.items.map((master) => (
              <React.Fragment key={master.bol_reference}>
                {/* Master Row */}
                <tr style={{ backgroundColor: "#e3f2fd", fontWeight: "600" }}>
                  <td><strong>{master.bol_reference} (Master)</strong></td>
                  <td>
                    {[master.service_name, master.packing_name, master.build_up_name]
                      .filter(Boolean)
                      .join(" + ") || "—"}
                  </td>
                  <td>{master.current_qty || 0}</td>
                  <td>{master.pieces || 0}</td>
                  <td>{formatNumber(master.weight || 0, 2)}</td>
                  <td style={{ fontWeight: "bold", color: (master.days || 0) > 5 ? "#c62828" : "inherit" }}>
                    {master.days || 0}
                  </td>
                  <td>{master.status || (master.is_delivered ? "Delivered" : "In Stock")}</td>
                  <td>{formatNumber(master.service_cost || 0, 2)}</td>
                  <td>{formatNumber(master.packing_cost || 0, 2)}</td>
                  <td>{formatNumber(master.build_up_cost || 0, 2)}</td>
                  <td>{formatNumber(master.storage_invoice_price || 0, 2)}</td>
                  <td style={{ fontWeight: "bold", color: "#2e7d32" }}>
                    {formatNumber(master.value || 0, 2)}
                  </td>
                </tr>

                {/* House Rows */}
                {master.children && master.children.length > 0 && 
                  master.children.map((house, idx) => (
                    <tr key={`${master.bol_reference}-house-${idx}`} style={{ backgroundColor: "#f8f9fa" }}>
                      <td style={{ paddingLeft: "45px" }}>↳ {house.bol_reference}</td>
                      <td style={{ color: "#777" }}>— House BOL</td>
                      <td>{house.current_qty || 0}</td>
                      <td>{house.pieces || 0}</td>
                      <td>{formatNumber(house.weight || 0, 2)}</td>
                      <td>—</td>
                      <td>In Stock</td>
                      <td colSpan={5} style={{ textAlign: "center", color: "#999" }}>— Calculated at Master Level —</td>
                    </tr>
                  ))
                }
              </React.Fragment>
            ))}
          </tbody>

          <tfoot>
            <tr style={{ backgroundColor: "#e8f5e9", fontWeight: "bold" }}>
              <td colSpan={11} style={{ textAlign: "right" }}>
                Grand Total Inventory Value:
              </td>
              <td>
                {formatNumber(stockByService.grandTotal || 0, 2)} USD
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    ) : (
      <p className="hint-text" style={{ marginTop: 12 }}>
        No stock data available. Click "Load Stock by Service" to fetch data.
      </p>
    )}
  </div>
)}

      {/* ===== Section 4: Stock Summary (Always visible for context) ===== */}
      {stockSummary && (
        <div className="card" style={{ marginTop: 12 }}>
          <h4 style={{ margin: 0 }}>Overall Stock Summary</h4>
          <div className="grid grid-auto" style={{ marginTop: 12 }}>
            <div className="field">
              <label>Current Qty (Total)</label>
              <input readOnly value={formatNumber(stockSummary.current_total ?? 0, 0)} />
            </div>
            <div className="field">
              <label>Total Added</label>
              <input readOnly value={formatNumber(stockSummary.total_added ?? 0, 0)} />
            </div>
            <div className="field">
              <label>Total Withdrawn</label>
              <input readOnly value={formatNumber(stockSummary.total_withdrawn ?? 0, 0)} />
            </div>
            <div className="field">
              <label>Withdrawn (From/To)</label>
              <input readOnly value={formatNumber(stockSummary.withdrawn_in_range ?? 0, 0)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
